const body = document.body;

function setAttr() {
  if (!body.hasAttribute('data-theme-nav')) {
    body.setAttribute('data-theme-nav', '');
  }

  if (!body.hasAttribute('data-bg-nav')) {
    body.setAttribute('data-bg-nav', '');
  }
}

function checkSections(sections) {
  for (let i = 0; i < sections.length; i++) {
    const themeSection = sections[i];
    const themeSectionTop = themeSection.getBoundingClientRect().top;
    const themeSectionBottom = themeSection.getBoundingClientRect().bottom;
    const themeObserverOffset = document.querySelector('.js-header').clientHeight;
    const themeObserverOffsetCenter = window.innerHeight / 2;

    if (themeSectionTop <= themeObserverOffset && themeSectionBottom >= themeObserverOffset) {
      const themeSectionActive = themeSection.dataset.themeSection;

      if (body.getAttribute('data-theme-nav') !== themeSectionActive) {
        body.setAttribute('data-theme-nav', themeSectionActive);
      }
    }

    if (themeSectionTop <= themeObserverOffsetCenter && themeSectionBottom >= themeObserverOffsetCenter) {
      const bgSectionActive = themeSection.dataset.themeSection;

      if (body.getAttribute('data-bg-nav') !== bgSectionActive) {
        body.setAttribute('data-bg-nav', bgSectionActive);
      }
    }
  }
}

export default function setTheming() {
  const sections = document.querySelectorAll('[data-theme-section]');

  if (sections.length) {
    document.addEventListener('scroll', () => {
      checkSections(sections);
    });
    setAttr();
    checkSections(sections);
  }
}
